import watchGetFAQItemsRequested from './getFAQItemsSaga';

export default [
  watchGetFAQItemsRequested(),
];
